/** Where the ticket's customer column is and what it shows (the discussion polish round, 2026-11-02; brief
 *  docs/briefs/discussion-polish-hours-editor-round.md rules 2 and 6, the red team's findings 1 and 10). Pure. Below 1600 px the column is a
 *  drawer (`?info=1`); at 1600 px and wider it is always there. The band's Customer and Discussion buttons and the discussion's condensed item
 *  write the same two address parts; the discussion counts as read only while its tab is on screen (DECISIONS "2026-11-02 — The discussion
 *  counts as read only while its tab shows"). */
export type ColumnTab = "profile" | "tickets" | "discussion";
/** the 1600 px line: a wider screen always shows the column */
export const WIDE_COLUMN = "(min-width: 1600px)";

/** the address parts that show a tab: `tab` (none for Profile) and, below 1600 px, the drawer */
export function columnParams(tab: ColumnTab, wide: boolean): { tab: string | null; info: "1" | null } {
  return { tab: tab === "profile" ? null : tab, info: wide ? null : "1" };
}

type ColumnState = { wide: boolean; open: boolean; tab: ColumnTab };
/** a tab is the one on screen: chosen, and the column shows (always when wide, with the drawer open below); the band's buttons are pressed
 *  while theirs shows */
export const tabOnScreen = (want: ColumnTab, o: ColumnState): boolean => o.tab === want && (o.wide || o.open);
/** the Discussion tab is visible (only then does the discussion's read mark move) */
export const discussionOnScreen = (o: ColumnState): boolean => tabOnScreen("discussion", o);
